import { APP_ID, Inject, NgModule, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from '@core/core.module';
import { NgxsStoreModule } from './ngxs-store/ngxs-store.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { API_BASE_URL } from '@core/services/api.service';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { NgxPaginationModule } from 'ngx-pagination';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { RouterExtService } from '@core/services/router-ext.service';
import { Ng2TelInputModule } from 'ng2-tel-input';

@NgModule({
  imports: [
    BrowserModule.withServerTransition({ appId: 'cellashop.ui' }),
    BrowserAnimationsModule,
    HttpClientModule,
    CommonModule,
    ToastrModule.forRoot({onActivateTick: true}),
    CoreModule,
    NgxPaginationModule,
    AppRoutingModule,
    NgxsStoreModule,
    Ng2TelInputModule 

  ],
  providers: [{ provide: API_BASE_URL, useFactory: getBaseUrl }, { provide: MAT_DATE_LOCALE, useValue: 'en-ZA' },RouterExtService], 
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    @Inject(APP_ID) private appId: string) {
    const platform = isPlatformBrowser(platformId) ?
      'in the browser' : 'on the server';
    console.log(`Running ${platform} with appId=${appId}`);
  }
}

export function getBaseUrl(): string {
  return environment.webApiBaseAddress;
}
